import React from "react";
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
} from "bizcharts";
import DataSet from "@antv/data-set";

function addCommas(nStr){
  nStr += '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? '.' + x[1] : '';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

class ProfileChart extends React.Component {
  render() {
    const { data = [], title, height } = this.props;
    const ds = new DataSet();
    const dv = ds.createView().source(data);
    return (
      <div>
        <Chart height={height || 500} width={600} data={dv}>
          <div className='main-title' style={{textAlign: 'center', fontSize: 28}}>{title}</div>
          <Coord transpose />
          <Axis
            name="y"
            
            label={{ formatter: (text) => (text || '').length >  10 ? `${text.substr(0, 10)}.` : text}}
          />
          <Axis name="x" label={{formatter: (text) => `$${addCommas(text)}`}} />
          <Tooltip />
          <Geom type="interval" position="y*x"
                color={['x', (x)=>{
                  if(x > 0)
                    return '#6cb36c';
                  else
                    return '#f97777';
                }]} />
        </Chart>
      </div>
    );
  }
}

export default ProfileChart;



// WEBPACK FOOTER //
// ./src/components/view-positions/ProfitChart.js